import { useMemo } from 'react';
import { useAuth } from '../../auth/hooks/useAuth';
import { useAccessToken } from '../../auth/hooks/useAccessToken';
import { useConsent } from '../../consent/hooks/useConsent';
import { useThemeStore } from '../../theme/store';
import { useLanguageStore } from '../../language/store';
import { useAuthStore } from '../../auth/store';
import type { EmbeddingContextData } from '../../../types/embedding';

export function useEmbeddingContext() {
  const { user } = useAuth();
  const { token } = useAccessToken();
  const entitlementsRefreshed = useAuthStore((state) => state.entitlementsRefreshed);
  const { preferences: consentPreferences } = useConsent();
  const theme = useThemeStore((state) => state.theme);
  const language = useLanguageStore((state) => state.language);

  const contextData = useMemo<EmbeddingContextData>(() => {
    return {
      auth: {
        token: token || undefined,
        entitlementsRefreshed,
        user: user
          ? {
              id: user.sub || '', // Ensure string
              name: user.email,
              email: user.email,
              roles: user.roles ?? [],
              permissions: user.permissions ?? [],
            }
          : undefined,
      },
      consent: {
        necessary: true,
        analytics: consentPreferences.analytics,
        marketing: consentPreferences.marketing,
        preferences: consentPreferences.functional,
      },
      theme,
      language,
    };
  }, [token, entitlementsRefreshed, user, consentPreferences, theme, language]);

  return contextData;
}
